import React, { Component } from "react";
import { withRouter } from "react-router";

import Container from "../../components/UI/Container/Container";

import {
  // BuyerLocations,
  DashboardInfo,
  EventsDetails,
  TicketsSales,
  TicketsSalesGraphic,
} from "../../components/DashboardSections";

import "./Dashboard.sass";
import browserTabTitleOverride from "../../helpers/tabTitleOverride";

class Dashboard extends Component {
  componentDidMount() {
    browserTabTitleOverride();
  }

  render() {
    return (
      <div className="dashboard">
        <Container className="dashboard__hero">
          <DashboardInfo />
          {/* <div className="dashboard__wrapper">
            <TicketsSalesGraphic />
            <BuyerLocations />
          </div> */}
          <div
            style={{
              marginTop: 30,
            }}
          >
            <TicketsSalesGraphic />
          </div>
          <div className="dashboard__wrapper">
            <TicketsSales />
            <EventsDetails />
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(Dashboard);
